<template>
  <div>
  
    <section  class="navbarsection" style="margin-top: -50px;">
          <div class="txtdata">
            <h1  style="padding-top: 200px;"></h1>
          </div>
            <div class="videosection" >
              <div  v-show="pvisvideo === true && pvpictureimage === false ">
                <Transition class="transition thing">
                  <video-background 
                    playbackRate=0.98
                    :src="src"
                    :poster="poster"
                    :class="`thing playercss`"
                    :style="`height: 600px;`">
                  </video-background>
                </Transition>
              </div>
            
                <div id="panorama"  v-show="pvisvideo === false && pvpictureimage === true"  :style="`height: 600px; padding-top: -5px; z-index: 1;`">
                </div>
      
                <img :src="poster" style="width: 100%; height: 600px;" class="imgcss" 
                v-show="pvisvideo === false && pvpictureimage === false || pvisvideo === true && pvpictureimage === true" />
       
          </div>
          <div class="overlay"></div>
          <div style="margin-top: -200px; color: white; margin-left: 50px; margin-bottom: 300px; ">
            <h1 class="" v-html="imagetext" :class="formatvhtml"></h1>
          </div>
        </section>

    <section class="purposecontainer">
      <div class="purposecarddiv card shadow" style="padding-right: 30px;">
        <div class="p-3" v-for="purpose in getpurpose">
          <h1 class="text-body-emphasis txtright" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="400"><span class="ourworkmatters">{{purpose.apdesc}}</span></h1>
          <p class="lead txtright workmattersdesc" v-html="purpose.apsec1text" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="400">
            
          </p>
          <div class="row txtright">
            <div class="col">
              <router-link :to="{path: purpose.approductlink}" class="formatlinks"> <i class="fa-solid fa-up-right-from-square formatlinksicons"></i><br><span>OUR PRODUCT</span></router-link>
            </div>
            <div class="col">
              <router-link :to="{path: purpose.apapproachlink}" class="formatlinks"><i class="fa-solid fa-up-right-from-square formatlinksicons"></i><br><span>OUR APPROACH & PERFORMANCE</span> </router-link>
            </div>
          </div>
        </div>
       
      </div>
    </section>
<!--     
    <section  class="secpef">
      <div  class="secpef">
        <div class="container-md" v-for="purpose1 in getpurpose">
          <div v-html="purpose1.commitperformancetext" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="400"></div>
        </div>
      </div>
      <AllCardsext :valuesphotos="valuesphotos" :cvpurposevaluelinkname="cvpurposevaluelinkname" 
      :cvlink="cvlink"  allcardsexttheme='allcardsextsection' :cardnumber="cardnum2" :cardwidth="cardwidth2" />
    </section> -->


    <!-- <StockCards :getstocks="getstocks" :class="stockcards" /> -->

    <AllsectionImages :cmimage1="cmimage1" :cmimage2="cmimage1" :cmimage3="cmimage3"  picimagetheme="picimagesection" />

    <AllCardsext :cvdesc="aboutcardcaption"  :valuesphotos="valuesphotosabout" :cvpurposevaluelinkname="cvpurposevaluelinkname" :cvlink="cvlink" 
    allcardsexttheme1='allcardsextsection1' :cvvisibility="cvvisibility" :cardnumber="cardnum1" :cardwidth="cardwidth1" />
<section>
  <div>


    <div class="container bottompagemsg">
      <hr class="hrclass"/>
      <span v-html="aboutgeneral.pdesc" class="hrspantext">
    
      </span>
    </div>  
  </div>
</section>


  </div>
</template>

<script>

// import StockCards from '@/components/StockCards.vue';
import RelMinerals from '@/components/RelMinerals.vue';
import ContainerFluid from '@/components/ContainerFluid.vue';
import ContSection from '@/components/ContSection.vue';
import AllcardsSection from '@/components/AllcardsSection.vue';
import AllCardsext from '@/components/AllCardsext.vue';
import AllsectionImages from '@/components/AllsectionImages.vue';
require('@/globalDeclare.js');
require('@/assets/css/pannellium-2.5.css');
require('@/assets/css/video-js.css');
// require('@/setup.js');
import axios from 'axios';


export default {
  name: 'AboutView',
  components: {
 RelMinerals, ContainerFluid, ContSection, AllcardsSection, AllCardsext, AllsectionImages
},
data() {
  return {
  videoimage: [],
  imagetext: '',
  src: '',
  playrate: '',
  poster: '',
  // pvwebm: '',
  // pvmp4: '',
  pvstyle: '',
  pvsrc: '',
  pvisvideo: false,
  pvpanorama1: '',
  pvpanorama2: '',
  pvpanorama3: '',
  pvhotspot1: '',
  pvhotspot2: '',
  pvhotspot3: '',
  showVideo: false,
  showPanorama: false,
  pictureimage: '',
  picurl: myUrlPath,


  aboutcardcaption: '',
  valuesphotos: [],
  valuesphotosabout: [],
  cvpurposevaluelinkname: '',
  cvlink: '',
  

  getpurpose: [],
  allyears: [],
  yearimages: [],
  contfluiddata: [],
  allcardsdata: [],
  contdata: [],
  aboutgeneral: [],
  cvvisibility: true,
  cardnum1: 2,
  cardnum2: 2,
  cardwidth1: '300px;',
  cardwidth2: '20%',
  
  histsearchid: 0,
  getlastimage: '',
  showImage: false,
  publicPath: window.location.origin,

  cmimage1: [],
  cmimage2: '',
  cmimage3: '',
  myPicUrl: '',

  }
},
methods: {
  logChange(event) {
    this.showImage = true
    this.histsearchid = event
    
  //------------Homepage Stock Prices---------------
  axios.get(`gethistorydataid/${this.histsearchid}`).then(
      response => {
          this.yearimages = response.data
    })
    .catch((error) => {
        console.log(error)
      })
}
},
mounted() {
  let showImage = Boolean
  showImage = false
  this.myPicUrl = myUrlPath
  axios.get('allpagespv/purpose').then(
    response => {
      this.videoimage = response.data
      
      this.imagetext = this.videoimage.pvdisplaytext 
      this.src = this.picurl + this.videoimage.pvsrc
      this.playrate = this.videoimage.playbackrate
      this.poster = this.picurl + this.videoimage.pvposter
      this.pvstyle = this.videoimage.pvstyle
      this.pvisvideo = this.videoimage.pvisvideo
      this.pvpanorama1 = this.picurl + this.videoimage.pvpanorama1
      this.pvpanorama2 = this.picurl + this.videoimage.pvpanorama2
      this.pvpanorama3 = this.picurl + this.videoimage.pvpanorama3
      this.pvhotspot1 = this.videoimage.pvhotspot1
      this.pvhotspot2 = this.videoimage.pvhotspot2
      this.pvhotspot3 = this.videoimage.pvhotspot3
      this.pvpictureimage = this.videoimage.pvpictureimage

      // let pvisvideo1 = this.videoimage.pvisvideo
      // this.pvisvideo = pvisvideo1
          const config = {
          autoLoad: true,
          scenchange: true,
          compass: false,
          northOffset: -237.5,
          default: {
              firstScene: "hotspotoffice",
              sceneFadeDuration: 1000,
              autoRotate: -.6,
              setTimeout: 100,
              preview: this.poster
              
          },
          scenes: {
              hotspotoffice: {
                  hfov: 180,
                  pitch: 0,
                  yaw: 0,
                  type: "equirectangular",
                  panorama: this.pvpanorama1,
                  hotSpots: [
                      {
                          pitch: 4,
                          yaw: 21.8,
                          type: "scene",
                          sceneId: "anotherhotspot",
                          text: this.pvhotspot1,
                      }
                  ]
              },
              anotherhotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama2,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "lasthotspot",
                            text: this.pvhotspot2,
                        }
                    ]
                },
                lasthotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama3,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "hotspotoffice",
                            text: this.pvhotspot3,
                        }
                    ]
                },
              
            }
        };
        pannellum.viewer('panorama', config);
  })
  .catch((error) => {
        console.log(error)
      })
  
  //---------------AllCardsext -------------------------
    axios.get('valuesphotos/investoverview').then(
      response => {
          this.valuesphotos = response.data
    })
    .catch((error) => {
        console.log(error)
      })

  //---------------AllCardsext -------------------------
  axios.get('valuesphotos/purpose').then(
        response => {
            this.valuesphotosabout = response.data
      })
      .catch((error) => {
          console.log(error)
        })
          
  //---------------AllCardsext Captions-------------------------
  axios.get('getcardcaption/purpose').then(
        response => {
            this.aboutcardcaption = response.data[0].captiondesc
      })
      .catch((error) => {
          console.log(error)
        })

        

    //------------Aboutpage purpose ---------------
    axios.get('getaboutpurposedata/').then(
      response => {
          this.getpurpose = response.data
    })
    .catch((error) => {
        console.log(error)
      })

    //------------Aboutpage purpose ---------------
  axios.get('getaboutpurposedatasingle/').then(
      response => {
          this.cmimage1 = response.data.cmimg1
          this.cmimage2 = response.data.cmimg2
          this.cmimage3 = response.data.cmimg3
    })
    .catch((error) => {
        console.log(error)
      })

    //------------Homepage Stock Prices---------------
axios.get('getallhistorydata/').then(
      response => {
          this.allyears = response.data
          this.getlastimage = this.allyears[this.allyears.length - 1]
    })
    .catch((error) => {
        console.log(error)
      })
      
    //------------Homepage Stock Prices---------------
axios.get('abouthistorysinglerecord/').then(
      response => {
          this.getlastimage = response.data
          this.getlastimage = response.data.abouthistimage
    })
    .catch((error) => {
        console.log(error)
      })

       
    //------------Container Fluid Section---------------
    axios.get('getcontainerfluiddata/purpose').then(
      response => {
          this.contfluiddata = response.data
    })
    .catch((error) => {
        console.log(error)
      })

      //------------Container Section---------------
  axios.get('getcontainerdata/purpose').then(
      response => {
          this.contdata = response.data
    })
    .catch((error) => {
        console.log(error)
      })
  //------------All Cards Section---------------
  axios.get('getallcardsectionsdata/purpose').then(
      response => {
          this.allcardsdata = response.data
    })
    .catch((error) => {
        console.log(error)
      })
  //------------All Cards Section---------------
axios.get('aboutpagegeneral/purpose').then(
    response => {
        this.aboutgeneral = response.data
  })
  .catch((error) => {
      console.log(error)
    })
      
}
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vendors/bootstrap-vue/_custom.scss";

.valuecardslinkname {
  text-align: center; 
  color: white; 
  font-size: 14px; 
  position: relative; 
  float: right;
}

.secpef {
  height: auto;
  margin-bottom: 0px;
  background-color:  #daf1f8;
}

.topdiv {
  width: 100%;
}
.middlediv {
  width: 100%;
}

.txtright {
  text-align: right;
}

.gradient-text {
  text-align: left;
  font-size: 16px;

}
.container {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: .2fr 1.2fr .2fr;
  grid-template-areas: 
  "nav nav nav" 
  "main main main" 
  "footer footer footer";
  grid-gap: 0.2rem;
  font-family: "Inter", sans-serif;
  font-size: 800;
  font-size: 12px;
  color: #234234;
  text-align: center;
}

html { 
  height: 100%;
  margin:0px;
  background: url('../assets/slide-5.jpg') no-repeat center center;
  background-size: cover;
  background-attachment: fixed;
}

main {
  background: white;
  grid-area: main;
  padding-left: 0px;
  padding-right: 0px;
  margin-left: 0px;
  margin-right: 0px;
  border-radius: 0px;
  margin-top:-5px;
}

.yearscontainer {
  background-color: grey;
  margin-top: -200px;
 }
.yearscontainergifbtm {
  margin-bottom: 20px;
}
.bottompagemsg{
  font-size: 18px;
  text-align: justify;
  border-top: solid thin grey;
}
.hrspantext {
  padding-top: 10px;
}
.allcardsextsection {
  margin-top: -100px;
  background-color: rgb(236, 236, 240);
}

.allcardsextsection1 {
  margin-top: 30px;
}

.imageswidth {
  max-width: 100%;
}
.picsimages {
  margin-top: -200px;
  width: 100%;
}

.cardcontainer {
  width: 80%;
  height: 400px;
  margin: 0 auto;
  margin-top: 100px;
}
.ourworkmatters {
  color: rgb(44, 102, 177);
  font-size: 40px;
  font-family:fantasy;
}
.formatlinks {
  text-decoration: none;
  font-weight: bold;
  color: rgb(44, 102, 177);
}
.imagescontainer {
  padding-left: 0rem;
  padding-right: 0rem;
  overflow: hidden;
}
.workmattersdesc {
  font-style: italic;
  font-size: 16px;
}
.formatlinksicons {
  font-size: 20px; 
  color: red;
  margin-top: 30px;
}
 
.purposecontainer {
  padding: 40px;
}
.posterimageclass {
  height: 70%; 
  margin-bottom: 200px; 
  width: 100%
}

.videosection {
  margin-top: -60px;
  height: 600px;
  width: 100%;
  background-color: #003;
}

 .overlay {
  opacity: 0.99;
  width: 100%;
  height: 600px;
  background: linear-gradient(to bottom, #003, transparent);
  margin-top: -600px;
}
img {

  object-fit: cover;

}
/*===================MEDIA SCREENS TAMPLATES===============*/
 /* Extra small devices (phones, 600px and down) */
 @media only screen and (max-width: 600px) {
  .purposecontainer {
    padding: 0 auto;
  }
 
  .posterimageclass {
    height: 300px; 
    margin-bottom: 200px; 
    width: 100%
  }
  .pantopsection {
    margin-top: -220px;
  }
  .purposecarddiv {
    margin-top: 50px;
    width: 96%;
    height: 500px;
  }
  .footerdiv {
    margin-top: 0px;
  }
  .secpef {
    padding: 20px;
  }

  .allcardsextsection {
    margin-top: 30px;
  }

 }

 /* Small devices (portrait tablets and large phones, 600px and up) */
 @media only screen and (min-width: 600px) {
 
  .posterimageclass {
    height: 300px; 
    margin-bottom: 200px; 
    width: 100%
  }
  .purposecarddiv {
    margin-top: 50px;
    min-width: 96%;
    height: 400px;
  }

  .footerdiv {
    margin-top: 1200px;
  }
  .secpef {
    padding: 20px;
  }

  .allcardsextsection {
    margin-top: 30px;
  }
   .footerdiv {
    margin-top: -100px;
   }
 }
 
 /* Medium devices (landscape tablets, 768px and up) */
 @media only screen and (min-width: 768px) {
  
  .posterimageclass {
    height: 300px; 
    margin-bottom: 200px; 
    width: 100%
  }
  .purposecontainer {
    width: 100%;
    padding-left: 50px;
  }

  .bottompagemsg{
    text-align: justify;
    padding-left: 30px;
    padding-right: 30px;
  }
  .pantopsection {
    margin-top: -290px;
  }

  .purposecarddiv {
    margin-top: 50px;
    min-width: 40%;
    height: 400px;
  }
  .purposecarddiv{
    height: 360px;
    width: 100%;
  }

  .picimagesection{
    margin-top: 100px;
  }
 .footerdiv {
  margin-top: -100px;
 }
 }


 /* Large devices (laptops/desktops, 992px and up) */
 @media only screen and (min-width: 992px) {
  .bottompagemsg{
    margin-bottom: -100px;
    text-align: justify;
    padding-left: 30px;
    padding-right: 30px;
  }
  .panimagesize {
    margin-top: 130px;
  }
  .txtdata {
    margin-bottom: 30px;
    width: 900px;
    padding-right: 10px;
  }
  .purposecontainer {
    padding-left: 160px;
    padding-right: 160px;
  }
  .secpef {
    padding-left: 70px;
    padding-right: 70px;
    padding-top: 50px;
    padding-bottom: 50px;
  }
 }
 
 /* Extra large devices (large laptops and desktops, 1200px and up) */
 @media only screen and (min-width: 1200px) {
  .bottompagemsg{
    margin-bottom: -100px;
    text-align: justify;
    padding-left: 30px;
    padding-right: 30px;
  }
  .pantopsection {
    margin-top: -290px;
  }
 
 } 
</style>

